import PridWwwMain from '#ui/PridWwwMain';
import React from 'react';
import ReactDOM from 'react-dom/client';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PridWwwMain />
  </React.StrictMode>,
);
